/**
 * Created by vladislav on 10.02.2020
 */

const KnockoutWindow = CleverappsWindow.extend({
    onWindowLoaded: function (rumble) {
        this.rumble = rumble;

        this._super({
            title: this.getTitle(),
            name: "knockoutwindow", 
            content: this.getContent(),
            closeButton: false
        });

        new ActionPlayer([
            function waitInitialization(f) {
                this.initializingText = this.createInitializingText();

                this.rumble.whenInitialize((success) => {
                    if (cleverapps.config.debugMode && this.rumble.outcome === Rumble.OUTCOME_UNKNOWN) {
                        const button = new cleverapps.UI.Button({
                            width: 200 * resolutionScale,
                            height: 100 * resolutionScale,
                            text: Messages.get("Skip"),
                            onClicked: function () {
                                this.close();
                            }.bind(this)
                        });
                        this.window.addChild(button);
                        button.setAlignment({ x: { align: "center" }, y: { align: "bottom", dy: -15 } });
                    }

                    if (success) {
                        f();
                    } else {
                        this.close();

                        cleverapps.knockoutGame.onRumbleInitFailed();
                    }
                });
            }.bind(this),

            function (f) {
                this.playersViews = this.rumble.rounds.map((round, index) => this.createPlayersForRound(round, this.rumble.rounds.length - index));

                this.rumble.rounds.forEach(function (round, id) {
                    if (id < this.rumble.rounds.length - 1) {
                        this.drawOldRound(round);
                    }
                }, this);

                if (this.rumble.getCurrentRound().id === 0) {
                    this.firstRound(f);
                } else {
                    this.updateGrid(f);
                }
            }.bind(this),

            function (f) {
                if (this.initializingText) {
                    this.initializingText.removeFromParent(true);
                    delete this.initializingText;
                }

                f();
            }.bind(this),

            this.finalAnimation.bind(this)
        ]).play();
    },

    getTitle: function () {
        const title = {};

        const currentRound = this.rumble.getCurrentRound();

        if (this.rumble.outcome !== Rumble.OUTCOME_UNKNOWN) {
            title.text = Messages.get("KnockoutWindow.Title.Victory");
        } else if (currentRound && currentRound.isLast()) {
            title.text = Messages.get("KnockoutWindow.Title.Final");
        } else {
            title.text = Messages.get("KnockoutWindow.Title.Round", {
                roundId: (currentRound && currentRound.id || 0) + 1
            });
        }

        return title;
    },

    updateGrid: function (f) {
        const prevRound = this.rumble.getPrevRound();
        const nextRound = this.rumble.getCurrentRound();

        const waiter = cleverapps.wait(nextRound.players.length, f);

        nextRound.players.forEach(function (playerId) {
            const isFake = playerId !== Rumble.PLAYER_ID;

            const delay = isFake ? Math.random() * 6 + 4 : 0;
            const silent = isFake ? Math.random() < 0.3 : false;

            const opponentId = prevRound.getOpponentId(playerId);
            this.playersViews[prevRound.id][opponentId].runLoseAnimation(silent, delay);

            this.playersViews[nextRound.id][playerId].runWinAnimation(waiter, silent, delay);
        }, this);
    },

    firstRound: function (f) {
        const round = this.rumble.getCurrentRound();

        const userIndex = round.players.indexOf(Rumble.PLAYER_ID);
        const animated = round.players.slice(userIndex + 1);

        const waiter = cleverapps.wait(animated.length + 1, f);

        setTimeout(waiter, 500);

        const delays = animated.map(() => Math.random() * 6 + 4).sort();

        animated.forEach(function (playerId, index) {
            this.playersViews[0][playerId].runStartAnimation(delays[index], waiter);
        }, this);
    },

    finalAnimation: function () {
        if (this.rumble.outcome === Rumble.OUTCOME_UNKNOWN) {
            this.runPlayCountdown();
        } else if (this.rumble.outcome === Rumble.OUTCOME_WIN) {
            this.runVictoryAnimation();
        } else {
            setTimeout(this.close.bind(this), 3000);
        }
    },

    runVictoryAnimation: function () {
        const styles = cleverapps.styles.KnockoutWindow;

        this.grid.setAnimation(0, "fadeout", false);

        const fadeOut = function (element) {
            element && element.runAction(new cc.FadeOut(0.5));
        };

        for (const roundId in this.playersViews) {
            for (const playerId in this.playersViews[roundId]) {
                this.playersViews[roundId][playerId].fadeOut();
            }
        }

        this.window.setCascadeOpacityEnabled(false);
        this.windowTitle.setCascadeOpacityEnabledRecursively(true);
        let items = [this.window, this.windowTitle];
        if (this.decors && this.decors.decors) {
            items = items.concat(Object.values(this.decors.decors));
        }
        items.forEach((item) => {
            if (item) {
                fadeOut(item);
            }
        });

        const targetScale = 1.3;
        const maxScale = 1.5;

        const first = this.cup.getPosition();
        const third = cc.p(this.content.width / 2, this.content.height / 2 + styles.victory.cup.dy);
        const second = cc.p(first.x + styles.victory.bezier.second.x, first.y + styles.victory.bezier.second.y);
        this.cup.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.Sequence(
                    new cc.ScaleTo(0.4, maxScale),
                    new cc.ScaleTo(0.4, targetScale)
                ),
                new cc.BezierTo(0.8, [first, second, third])
            ),
            new cc.CallFunc(() => {
                const scene = cleverapps.Scenes.GetRunningScene();
                this.cup.replaceParentSamePlace(scene);
                this.cup.stopAllActions();
                scene.knockoutVictoryCup = this.cup;
                this.close();
            })
        ));

        cleverapps.effects.fire("victory.window.show");
    },

    runPlayCountdown: function () {
        const styles = cleverapps.styles.KnockoutWindow;

        const countdown = 3;

        this.countDown = new AnimatedCounterComponent({
            from: countdown,
            to: 1,
            font: cleverapps.styles.FONTS.KNOCKOUT_WINDOW_COUNTDOWN_TEXT,
            scale: 1.5,
            sfx: true,
            onFinish: this.close.bind(this)
        });
        this.content.addChild(this.countDown);
        this.countDown.setAlignment(styles.countdownText);
        this.countDown.runAnimation();
    },

    createPlayersForRound: function (round, zOrder) {
        const roundPlayerViews = {};
        round.players.forEach(function (playerId) {
            const view = new GridPlayerView(round, playerId);
            roundPlayerViews[playerId] = view;
            this.content.addChild(view, zOrder);
        }, this);

        return roundPlayerViews;
    },

    drawOldRound: function (round) {
        round.players.forEach(function (playerId) {
            if (round.isWinner(playerId)) {
                this.playersViews[round.id][playerId].setWon();
            } else {
                this.playersViews[round.id][playerId].setLost();
            }
        }, this);
    },

    getContent: function () {
        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(cleverapps.styles.KnockoutWindow.content);

        this.content.addChild(this.createGrid());
        this.content.addChild(this.createCup());

        return content;
    },

    createGrid: function () {
        const grid = this.grid = new cleverapps.Spine(bundles.battle.jsons.grid_json);
        grid.setAlignment(this.content.width / 2, this.content.height / 2);
        grid.setAnimation(0, "animation", true);
        this.content.setCascadeOpacityEnabled(true);
        grid.setCascadeOpacityEnabled(true);

        return grid;
    },

    createCup: function () {
        const cup = this.cup = new cc.Node();
        cup.setAnchorPoint(0.5, 0.5);
        cup.setContentSize2(cleverapps.styles.KnockoutWindow.cup);
        cup.setAlignment(cleverapps.styles.KnockoutWindow.cup);
        cup.setLocalZOrder(10);

        const animation = new cleverapps.Spine(bundles.knockout_cup.jsons.cup_json);
        cup.addChild(animation);
        animation.setAlignment(cup.width / 2, cup.height / 2);
        animation.setAnimation(0, "animation", true);

        cup.setScale(0.7);
        cup.baseScale = cup.scale;

        return cup;
    },

    createInitializingText: function () {
        const styles = cleverapps.styles.KnockoutWindow.loadingText;

        let msg;
        if (this.rumble.rounds.length === 0) {
            msg = Messages.get("KnockoutWindow.loading");
        } else if (this.rumble.outcome === Rumble.OUTCOME_UNKNOWN) {
            msg = Messages.get("KnockoutWindow.waitingForPlayers");
        }
        if (!msg) {
            return;
        }

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(`${msg}   `, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        this.content.addChild(text);
        text.setAlignment(styles);
        text.setDimensions(styles.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        let dots = "";
        let spaces = "   ";
        text.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.CallFunc(() => {
                    dots = (dots === "...") ? "." : (`${dots}.`);
                    spaces = (spaces === "") ? "  " : spaces.slice(1);
                    text.setString(msg + dots + spaces);
                    text.setAlignment(styles);
                }),
                new cc.DelayTime(0.5)
            )
        ));

        return text;
    },

    listBundles: function () {
        return ["battle", "victory_window"];
    }
});

cleverapps.styles.KnockoutWindow = {
    content: {
        width: 600,
        height: 1070
    },
    loadingText: {
        x: { align: "left", dx: -20 },
        y: { align: "center", dy: 0 },
        width: 200
    },
    countdownText: {
        x: { align: "left", dx: 30 },
        y: { align: "center", dy: 0 }
    },
    cup: {
        width: 200,
        height: 200,
        x: { align: "center", dx: 200 },
        y: { align: "center" }
    },
    victory: {
        bezier: {
            second: {
                x: -25,
                y: 400
            }
        },
        cup: {
            dy: 50
        }
    }
};